import React from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import styles from '@/b2c/MyPlan/PlanTableHeader.module.css';

const HeaderItem = ({
  onClick,
  sortColumn,
  currentSortColumn,
  columnName,
  order,
}) => (
  <th colSpan={sortColumn === 'productCategory' ? '2' : '0'}>
    <button
      type='button'
      className={`btn btn-link ${styles['sort-btn']}`}
      onClick={() => onClick(sortColumn)}
    >
      {columnName}
    </button>
    {currentSortColumn === sortColumn && (
      <i className={`material-icons ${styles['sort-icon']}`}>
        {order === 'desc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
      </i>
    )}
  </th>
);

const PlanTableHeader = ({onClick, currentSortColumn, order}) => {
  const {t: tr} = useTranslation('myPlan');

  const sortColumnList = {
    productCategory: tr('product_category'),
    productName: tr('product_name'),
    policyStatusCode: tr('policy_status'),
    planNo: tr('policy_no'),
  };

  const list = R.compose(
    R.map(([columnName, columnValue]) => (
      <HeaderItem
        key={columnName}
        onClick={onClick}
        sortColumn={columnName}
        currentSortColumn={currentSortColumn}
        columnName={columnValue}
        order={order}
      />
    )),
    R.toPairs
  )(sortColumnList);

  return <tr>{list}</tr>;
};

export default PlanTableHeader;
